<script lang="tsx" setup>
import { twMerge, type ClassNameValue } from "tailwind-merge";
import { SVGAttributes } from "vue";

interface Props extends /* @vue-ignore */ SVGAttributes {
  name: string;
  class?: ClassNameValue | any;
  tips?: string;
  loading?: boolean;
}

const props = defineProps<Props>();
</script>
<template>
  <template v-if="tips">
    <el-tooltip
      class="xxx"
      :content="tips"
      placement="top"
      :enterable="false"
      :show-arrow="false"
      popper-class="tg-tooltip !bg-slate-950 !bg-opacity-95 !p-2"
    >
      <svg
        v-bind="$attrs"
        :class="
          twMerge(
            'inline-block h-[1.2em] w-[1.2em] fill-current align-middle outline-none',
            props.class
          )
        "
      >
        <use :xlink:href="`#icon-${props.name}`"></use>
      </svg>
    </el-tooltip>
  </template>
  <svg
    v-else
    v-bind="$attrs"
    :class="
      twMerge(
        'inline-block h-[1.2em] w-[1.2em] fill-current align-middle outline-none',
        loading ? 'loading-svg' : '',
        props.class
      )
    "
  >
    <use :xlink:href="`#icon-${props.name}`"></use>
  </svg>
</template>

<style scoped>
@keyframes loading {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loading-svg {
  animation: loading 0.6s infinite linear;
}
</style>
